export default __webpack_public_path__ + "static/add-payment-25c3d570d96035539e72ada5a6a4e092.png";